import React, { Fragment } from 'react';
import { css, StyleSheet } from 'aphrodite';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';

import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { CommonStyles } from '../../styles/Styles';
import { StatCard } from '../../common/components/StatCard';
import { FilterBar } from '../../components/FilterBar';
import { AppHelper } from '../../helpers/AppHelper';
import { Controller } from '../../common/Controller';
import { Stats } from '../../components/Stats';
import { AppUiHelper } from '../../helpers/AppUiHelper';
// import { DateRangePicker } from '../../common/components/charts/DateRangePicker';
import { Toast } from '../../components/Toast';
import { VenueSummary } from '../../components/VenueSummary';
import { AdPopFilterBar } from '../../components/AdPopFilterBar';
import { ApiHelper } from '../../common/helpers/ApiHelper';
const queryString = require('query-string');

export class RevenueOrg extends BaseEntityPage {
  state = {
    // year: moment.utc(Helper.currentTs()).local().format('YYYY'),
    // month: moment.utc(Helper.currentTs()).local().format('MM'),
    dateStart: moment().subtract(30, 'day').format('YYYY-MM-DD'),
    dateEnd: moment().subtract(1, 'day').format('YYYY-MM-DD'),
    groupBy: [],
    inProcessFilter: false,
    showToast: false,
    severity: 'info',
    toastMsg: '',
  };
  groupByOptions = [{ key: 'DAY', value: 'DAY' }, { key: 'MONTH', value: 'MONTH' }]

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'Revenue'
    this.pageTitle = Helper.getString('revenue')
    this.orgId = this.props.match.params.orgId
    this.query = queryString.parse(props.location.search)
    this.uploadLocation = this.orgId
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: Helper.getString('revenueVenue') },
    ]
    // this.year = moment.utc(Helper.currentTs()).local().format('YYYY')
    // this.month = moment.utc(Helper.currentTs()).local().format('MM')
    this.toFetch = this.makeFetches()
    this.tableHeadersMap = {
      Index: (current) => {
        return (
          <div className={css(Styles.indexColumn)}>
            {current.__index + 1}
          </div>
        )
      },
      Venue: (current) => {
        return (
          <div className={css(Styles.venueColumn)}>
            <VenueSummary
              key={current.id || current.venueCode}
              item={current}
              site={{ title: current.title, address: current.address }}
              deviceCodeNode={current.venueCode}
              showVenueTitle={false}
              showArchived={true}
              showNotRegistered={false}
              showTesting={false}
              showExtId={false}
            />
          </div>
        )
      },
      Period: (current) => {
        return (
          <div className={css(Styles.infoColumn)}>
            {current.period &&
              <Fragment>
                <span className={css(Styles.line2)}>{current.period}</span>
              </Fragment>
            }
          </div>
        )
      },
      Info: (current) => {
        return (
          <div className={css(Styles.infoColumn)}>
            {current.phones &&
              <Fragment>
                <span className={css(Styles.line2)}>{current.phones}</span>
              </Fragment>
            }
          </div>
        )
      },
      Revenue: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{'$' + ((current.rev && current.rev.toFixed(2)) || 0)}</span>
            <br/>
          </div>
        )
      },
      Status: (current) => {
        return (
          <Fragment>
            {(current.latestDeviceFeed && current.latestDeviceFeed.currentTs) ?
              <Tooltip title={AppHelper.formatActiveTime(Helper.currentTs() - current.latestDeviceFeed.currentTs)} arrow>
                <div className={css(Styles.circleFill)} style={{ backgroundColor: AppHelper.getVenueStatusColor(Helper.currentTs() - current.latestDeviceFeed.currentTs) }}></div>
              </Tooltip>
              :
              AppHelper.offlineStatus()
            }
          </Fragment>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
    }
    this.noAdd = true
    this.noTableHead = true
    this.export = {
      buttonTitle:'Download',
      headers: {
        venueCode: 'venueCode', title: 'name', address: 'address', serialNumber: 'serialNumber', onlineStatus: 'onlineStatus', phones: 'phones', period: 'period', _revenue: 'revenue($)'
      },
      format: 'xlsx'
    }
  }

  makeFetches(dateStart, dateEnd, groupBy) {
    const selectedGroupBy = Array.isArray(groupBy) ? groupBy[0] : groupBy
    const queryParams = {
      // yyyymm: (year || this.year) + (month || this.month),
      startDate: dateStart || this.state.dateStart,
      endDate: dateEnd || this.state.dateEnd,
    }
    if (selectedGroupBy) {
      queryParams.groupBy = selectedGroupBy
    }
    if (this.query && this.query.show) {
      queryParams.show = this.query.show
    }
    if(this.options.pageForOrgType === 'SITE') {
      queryParams.siteOrgId = this.orgId
    } else if(this.options.pageForOrgType === 'PA') {
      queryParams.paOrgId = this.orgId
    } else if(this.options.pageForOrgType === 'FA') {
      queryParams.faOrgId = this.orgId
    }
    return [
      { method: 'GET', paths: ['miscs', 'rev'], queryParams },
      { method: 'GET', paths: ['orgs', this.orgId] },
    ];
  }

  onFetchSuccess(results) {
    this.revenue = results[0]
    if (results[1]) {
      this.org = results[1]
      this.pageTitle = this.org.title
    }
    results[0].items.forEach(i => i._revenue = (i.rev && i.rev.toFixed(2) || 0))
    this.setState({
      items: results[0].items,
      inProcessFilter: false,
    })
  }

  fetchRevenueData = () => {
    const request = this.makeFetches(
      this.state.dateStart,
      this.state.dateEnd,
      this.state.groupBy
    )[0]

    ApiHelper.call(
      request,
      function (err, data) {
        if (err) {
          this.setState({
            inProcessFilter: false,
            showToast: true,
            severity: 'error',
            toastMsg: Helper.getErrorMsg(err)
          })
          return
        }

        this.onFetchSuccess([data])
      }.bind(this)
    )
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  // onFilter(year, month) {
  //   this.setState({
  //     year,
  //     month
  //   })
  //   this.toFetch = this.makeFetches(year, month)
  //   this.fetchItems()
  // }

  onError = (toastMsg) => {
    this.setState({
      inProcessFilter: false,
      showToast: true,
      severity: 'error',
      toastMsg
    })
  }

getToast = () => {
  return (
    <Toast
      open={this.state.showToast}
      severity={this.state.severity}
      message={this.state.toastMsg}
      handleClose={() => this.setState({ showToast: false })}
    />
  )
}

  onFilter = ({ dateStart, dateEnd, groupBy }) => {
    const start = moment(dateStart)
    const end = moment(dateEnd)

    if (end.diff(start, 'months', true) > 12) {
      this.setState({
        dateStart,
        dateEnd,
        groupBy: groupBy || [],
      })
      this.onError(Helper.getString('revDateRangeExceeded'))
      return
    }

    this.setState({
      dateStart,
      dateEnd,
      groupBy: groupBy || [],
      inProcessFilter: true,
    }, () => {
      this.fetchRevenueData()
    })

    // TEMP: backend not ready for true date range yet
    // this.toFetch = this.makeFetches(dateStart, dateEnd)
    // this.fetchItems()
  }

 makeFileName = () => {
   const { dateStart, dateEnd } = this.state
   if (dateStart && dateEnd) {
     return `revenue-${dateStart.replaceAll('-', '')}-${dateEnd.replaceAll('-', '')}`
   }
   return `revenue-${Helper.currentTs()}`
 }

  checkKeyForAbbr = (key) => {
    const abbrKeys = ['VENUES', 'CAMPAIGNS', 'CREATIVES'];
    return !abbrKeys.includes(key.toUpperCase());
  }

  exportRowItemValue(key, current) {
    const serialNumber = current.latestDeviceFeed && current.latestDeviceFeed.serialnumber
      ? current.latestDeviceFeed.serialnumber
      : current.serialNumber

    switch (key) {
    case 'serialNumber':
      return serialNumber || ''
    case 'onlineStatus':
      return current.onlineStatus || ''
    case 'phones':
      return current.phones || ''
    default:
      return super.exportRowItemValue(key, current)
    }
  }

  renderAboveTable() {
    const statusImage = AppUiHelper.getReportsStatsImages()
    const tiles = [
      {
        title: 'Revenue',
        value: (this.revenue && this.revenue.total && this.revenue.total.toFixed(2)) || 0,
        image: statusImage.revenue
      },
      {
        title: 'Screens',
        value: this.checkKeyForAbbr('Venues') ? AppHelper.abbrNum(this.revenue && this.revenue.venueCount || 0) : this.revenue && this.revenue.venueCount || 0,
        image: statusImage.venues
      }
    ]
    // const getPeriods = () => {
    //   const currentYear = new Date().getFullYear()
    //   const startYear = 2023
    //   return {
    //     months: [
    //       { key: '01', label: 'Jan' },
    //       { key: '02', label: 'Feb' },
    //       { key: '03', label: 'Mar' },
    //       { key: '04', label: 'Apr' },
    //       { key: '05', label: 'May' },
    //       { key: '06', label: 'Jun' },
    //       { key: '07', label: 'Jul' },
    //       { key: '08', label: 'Aug' },
    //       { key: '09', label: 'Sep' },
    //       { key: '10', label: 'Oct' },
    //       { key: '11', label: 'Nov' },
    //       { key: '12', label: 'Dec' },
    //     ],
    //     years: Array.from({ length: currentYear - startYear + 1 }, (_, i) => {
    //       const year = startYear + i
    //       return { key: `${year}`, label: `${year}` }
    //     }).reverse(),
    //   };
    // };

    // const periods = getPeriods()

    return (
      <div className={css(Styles.renderAboveTable)}>
        {this.getToast()}
        { tiles && <Stats items={tiles}></Stats> }
        <AdPopFilterBar
          buttonLabel={Helper.getString('filter')}
          showQuickDateRangePicker={true}
          inProcess={this.state.inProcessFilter}
          onFilter={this.onFilter}
          dateEnd={this.state.dateEnd}
          dateStart={this.state.dateStart}
          groupBy={this.state.groupBy}
          groupByOptions={this.groupByOptions}
          groupBySingleSelect={true}
          groupByFullWidth={true}
          allowEmptyGroupBy={true}
        />
      </div>
    )
  }

  onActions(current) {
    const actions = []
    return actions
  }
}

const Styles = StyleSheet.create({
  indexColumn:{
    '@media (max-width: 1024px)': {
      minWidth: 20
    }
  },
  venueColumn:{
    '@media (max-width: 1024px)': {
      minWidth: 100
    }
  },
  infoColumn: {
    '@media (max-width: 1024px)': {
      minWidth: 200
    }
  },
  spanValue: {
    // fontSize: 14
  },
  img: {
    height: 30
  },
  line2: {
    fontSize: 12
  },
  renderAboveTable: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center'
  },
  circleFill:{
    width: 18,
    height: 18,
    borderRadius: '50%',
  }
})



// WEBPACK FOOTER //
// ./src/screens/admin/RevenueOrg.js